import {
  CreateJobCatalogNodeAttributeDocument,
  CreateJobCatalogNodeAttributeMutation,
  JobCatalogWorkingConditionsAttributeInput,
  NodePageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import { getChildNodeType } from 'modules/job_catalog/lib/nodesUtils'
import {
  WorkingConditions,
  workingConditionsToAttribute,
} from 'modules/job_catalog/lib/workingConditions'

const useCreateJobCatalogAttribute = () => {
  const [mutate, { loading }] = useMutation(CreateJobCatalogNodeAttributeDocument, {
    extractorFn: (data: CreateJobCatalogNodeAttributeMutation) =>
      data.jobCatalogMutations.createJobcatalogNodeAttribute,
  })

  const createSalary = (companyId: number, nodeUuid: string, serializedAttribute: string) => {
    return createAttribute(companyId, nodeUuid, 'salary_range', {}, serializedAttribute)
  }

  const createWorkingConditions = (
    companyId: number,
    nodeUuid: string,
    workingConditions: WorkingConditions
  ) => {
    return createAttribute(
      companyId,
      nodeUuid,
      'working_conditions',
      workingConditionsToAttribute(workingConditions)
    )
  }

  const createAttribute = (
    companyId: number,
    nodeUuid: string,
    attributeType: string,
    attribute: { valueWorkingConditions?: JobCatalogWorkingConditionsAttributeInput },
    serializedValue?: string
  ) => {
    const childType = getChildNodeType(nodeUuid)

    return mutate({
      variables: {
        companyId,
        nodeUuid,
        attributeType,
        ...attribute,
        valueJson: serializedValue,
      },
      refetchQueries: [
        {
          query: NodePageDocument,
          variables: {
            childType,
            nodeUuid,
          },
        },
      ],
    })
  }

  return { createSalary, createWorkingConditions, loading }
}

export default useCreateJobCatalogAttribute
